exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".allScreen[data-v-ebb6aada]{position:fixed;left:0;right:0;bottom:0;top:0;background-color:#f3f3f3;color:#000;display:flex;justify-content:center;align-items:center}.fade-enter-active[data-v-ebb6aada],.fade-leave-active[data-v-ebb6aada]{transition:opacity 1s}.fade-enter[data-v-ebb6aada],.fade-leave-to[data-v-ebb6aada]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ebb6aada","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LoadingImg.vue
// module id = 232
// module chunks = 0